export default __webpack_public_path__ + "static/media/330_dummy2016-zahnarzt01-mobile-de.eec47478.png";